/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { Alert } from 'reactstrap';

import * as url from '../../helpers/url_helper';
import { get } from '../../helpers/api_helper';

function ProfileSelector(props) {
  // eslint-disable-next-line no-unused-vars
  const { t, onSelect } = props;

  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const profilesData = await get(url.GET_PROFILES);

        setProfiles(profilesData.results);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();
  }, []);

  const jsx = (
    <select
      className="form-control"
      onChange={(e) => {
        for (let i = 0; i < profiles.length; i += 1) {
          if (e.target.value === profiles[i].id.toString()) {
            onSelect(profiles[i]);
          }
        }
      }}
    >
      <option value="">{t('Select a profile...')}</option>
      {loading === false && profiles.length > 0 && profiles.map((x) => (
        <option key={x.id} value={x.id}>{x.name}</option>
      ))}
      {loading === true && (
        <option value="">Loading...</option>
      )}
      {error !== false && (
        <Alert color="danger">
          {error}
        </Alert>
      )}
    </select>
  );

  return jsx;
}

ProfileSelector.defaultProps = {
  t: (x) => (x),
  onSelect: () => {},
};

ProfileSelector.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  onSelect: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(ProfileSelector));
